module.exports = __webpack_public_path__ + "img/tickets-r3-link-mgt.a87f21b3.png";